import { c as _c } from "react/compiler-runtime";
import { usePageFilters } from "@/components/providers/AppFilterProvider/AppFilterProvider";
import { getActiveFilterCount } from "../../utils";
export function useMobileFilterOrchestrator(pageKey) {
  const $ = _c(4);
  const {
    filters: pageFilters
  } = usePageFilters(pageKey);
  let t0;
  if ($[0] !== pageFilters) {
    t0 = getActiveFilterCount(pageFilters);
    $[0] = pageFilters;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const totalActiveFilters = t0;
  let t1;
  if ($[2] !== totalActiveFilters) {
    t1 = {
      totalActiveFilters
    };
    $[2] = totalActiveFilters;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}